import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { Spacer } from "@coworker/apprestructured/src/shared/components/Spacer/Spacer";
import { ItemLocation } from "@coworker/apprestructured/src/shared/components/item-cards/ItemLocation/ItemLocation";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemCriteriaStatus } from "@coworker/apprestructured/src/testbuy/components/ItemCriteriaStatus/ItemCriteriaStatus";
import { TestBuyProductWithCriteria } from "@coworker/types/lib/testbuy";
import React from "react";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import styles from "../../styles/testbuy-common-styles.module.css";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";

interface ItemCardTestBuyProps {
  item: Item;
  homeLocationGridCode: string;
  testbuyItem: TestBuyProductWithCriteria;
  badges?: ItemBadge[];
  canCopyItemNo?: boolean;
}

export const TestbuyItemCard = ({
  item,
  badges,
  homeLocationGridCode,
  testbuyItem,
  canCopyItemNo,
}: ItemCardTestBuyProps) => {
  return (
    <ItemCard badges={badges || []}>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.smallImageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          {canCopyItemNo ? (
            <ItemNoWithCopy itemNo={item.noFormatted} />
          ) : (
            <ItemNo itemNo={item.noFormatted} />
          )}
          <ItemDescription description={item.description || ""} />
          <Spacer />
          {homeLocationGridCode !== "no_location" && (
            <ItemLocation locationGridCode={homeLocationGridCode} />
          )}
          <ItemCriteriaStatus testbuyItem={testbuyItem} />
        </div>
      </div>
    </ItemCard>
  );
};
